import { render, staticRenderFns } from "./SmplListRfid.vue?vue&type=template&id=3373a012&scoped=true&"
import script from "./SmplListRfid.vue?vue&type=script&lang=js&"
export * from "./SmplListRfid.vue?vue&type=script&lang=js&"
import style0 from "./SmplListRfid.vue?vue&type=style&index=0&id=3373a012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3373a012",
  null
  
)

export default component.exports